import { HamburgerMenuIcon } from "@radix-ui/react-icons";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import MenuDrawer from "./MenuDrawer";
import UserSettings from "./UserSettings";
import { Button } from "./ui/button";
import UserAvatar from "./userAvatar";

export default function Header() {
  const user = useSelector((state: any) => state.user);

  return (
    <header
      style={{
        height: "4rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.5rem",
        gap: "1rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <MenuDrawer>
          <Button size="icon" variant="ghost">
            <HamburgerMenuIcon />
          </Button>
        </MenuDrawer>
        <Link to={"/"}>
          <h1 style={{ fontWeight: "bold", fontSize: "1.25rem" }}>Alkulačka</h1>
        </Link>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          position: "relative",
        }}
      >
        {/* <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="icon">
              <SunIcon className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
              <MoonIcon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
              <span className="sr-only">Toggle theme</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => dispatch(setTheme(themes.Light))}>
              Světlý
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => dispatch(setTheme(themes.Dark))}>
              Tmavý
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => dispatch(setTheme(themes.System))}>
              Podle systému
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <SyncDrawer>
          <Button size="icon" variant="outline">
            <img
              src="/cloud-icon.svg"
              alt=""
              style={{
                filter: theme === "dark" ? "invert(1)" : undefined,
              }}
            />
          </Button>
        </SyncDrawer> */}
        <UserSettings>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <UserAvatar friend={user} />
          </div>
        </UserSettings>
      </div>
    </header>
  );
}
